// src/ConfirmPage.tsx — ohjaa vanhasta token-vahvistuksesta PIN-kirjautumiseen
import Wordmark from "./components/Wordmark";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ConfirmPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate("/"), 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(160deg, #061a09 0%, #0a2e10 60%, #061a09 100%)",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      padding: 24, fontFamily: "'Sora','Segoe UI',sans-serif",
      textAlign: "center",
    }}>
      <img src="/logo192.png" alt="Spinloop" style={{ width: 80, borderRadius: 16, marginBottom: 24 }} />

      <div style={{ fontSize: 28, fontWeight: 900, color: "#fff", marginBottom: 8 }}>
        <Wordmark />
      </div>

      <div style={{
        background: "rgba(245,158,11,0.1)",
        border: "1px solid rgba(245,158,11,0.4)",
        borderRadius: 16, padding: "20px 24px",
        maxWidth: 340, marginTop: 24, marginBottom: 32,
      }}>
        <div style={{ fontSize: 32, marginBottom: 12 }}>🔑</div>
        <div style={{ fontSize: 16, fontWeight: 700, color: "#fff", marginBottom: 8 }}>
          Käytä PIN-koodia
        </div>
        <div style={{ fontSize: 13, color: "#a0aec0", lineHeight: 1.6 }}>
          Tämä vahvistuslinkki on vanhentunut.
          <br /><br />
          Kirjaudu sisään sähköpostissa saamallasi
          <strong style={{ color: "#f59e0b" }}> PIN-koodilla</strong> etusivulla.
        </div>
      </div>

      <div style={{ fontSize: 12, color: "#4a5568", marginBottom: 16 }}>
        Sinut ohjataan etusivulle 5 sekunnin kuluttua...
      </div>

      <button
        onClick={() => navigate("/")}
        style={{
          background: "linear-gradient(135deg, #16a34a, #4ade80)",
          color: "#fff", border: "none", borderRadius: 12,
          padding: "12px 28px", fontSize: 14, fontWeight: 700,
          cursor: "pointer",
        }}
      >
        Siirry etusivulle →
      </button>
    </div>
  );
};

export default ConfirmPage;
